/* eslint-disable max-len */
import { SUPPORTED_LANGUAGES } from '../../common/constants';

/**
 * This function takes an english CMS data object and a locale, and returns a new object prioritizing the values of the locale object over the default (english) values. If a translated value is not found, or the key is in the doNotTranslateKeys list, the original value is used.
 * @param {Object} cmsDataObject The CMS data object to be translated (should contain a `locales` property)
 * @param {*} locale The locale to translate to (will not be translated if not in SUPPORTED_LANGUAGES)
 * @param {*} doNotTranslateKeys A string array of keys of the cmsDataObject that should not use the locales version of the property as the final value
 * @returns {Object} A new CMS data object containing the translated values without the original `locales` property (where they could be found or used)
 */
export default function buildTranslatedCMSDataObject(cmsDataObject, locale, doNotTranslateKeys = []) {
  if (!cmsDataObject) {
    return null;
  }

  let translatedCMSDataObject = { ...cmsDataObject };
  if (Object.values(SUPPORTED_LANGUAGES).includes(locale) && cmsDataObject.locales?.[locale]) {
    translatedCMSDataObject = {
      ...Object.keys(cmsDataObject).reduce((localized, key) => {
        // Do not include the locales key in the final object
        if (key !== 'locales') {
          if (doNotTranslateKeys.includes(key)) {
            localized[key] = cmsDataObject[key];
          } else {
            localized[key] = cmsDataObject.locales[locale][key] || cmsDataObject[key];
          }
        }
        return localized;
      }, {}),
    };
  }
  return translatedCMSDataObject;
}
